(ns app.api-credential.register
  "UI register entries for the API credential slice."
  (:require [app.api-credential.create-modal :as create-modal]
            [app.api-credential.page :as page]))

(def register
  [page/page
   create-modal/modal])
